/**
 * Sprint 9 refactor — pulled out of NewDeployment.jsx to keep that
 * page under 400 lines. No behavior change.
 *
 * The demographics editor: a key + comma-separated values input pair
 * per row, with add/remove. Each row carries a stable `_id` so React
 * can preserve input focus when rows above are removed.
 */
import React from "react";


export default function DemographicsSection({ demos, updateDemo, removeDemoRow, addDemoRow }) {
  return (
    <section data-testid="demographics-section">
      <h2
        className="text-base mb-2"
        style={{ fontFamily: "Oswald", letterSpacing: "0.15em", textTransform: "uppercase", color: "#2F6B7C" }}
      >
        Demographics
      </h2>
      <p className="text-sm text-gray-700 mb-4 max-w-prose">
        The segmentation dimensions for the heatmap. Common ones: team, role, tenure. Each row is
        a key plus its allowed values — type one value per line, or separate them with commas.
        Leave empty to skip demographic segmentation.
      </p>
      <div className="space-y-2">
        {demos.map((row, idx) => (
          <div key={row._id} className="flex items-start gap-3" data-testid={`demo-row-${idx}`}>
            <input
              type="text"
              value={row.key}
              onChange={(e) => updateDemo(idx, "key", e.target.value)}
              placeholder="team"
              data-testid={`demo-key-${idx}`}
              style={{
                width: "180px", padding: "10px 12px",
                border: "1px solid #E0E0E0", background: "white", fontSize: "14px",
              }}
            />
            <textarea
              value={row.values}
              onChange={(e) => updateDemo(idx, "values", e.target.value)}
              placeholder={"MSL Manager\nField Trainer\nLiaison Manager\n…\n(or comma-separated)"}
              rows={Math.max(2, row.values.split(/[,\n;]+/).filter(Boolean).length)}
              data-testid={`demo-values-${idx}`}
              style={{
                flex: 1, padding: "10px 12px",
                border: "1px solid #E0E0E0", background: "white", fontSize: "14px",
                fontFamily: "Inter", lineHeight: 1.4, resize: "vertical",
              }}
            />
            <button
              type="button"
              onClick={() => removeDemoRow(idx)}
              className="btn-quiet text-xs"
              style={{ color: "#AD393E" }}
              data-testid={`demo-remove-${idx}`}
            >
              Remove
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={addDemoRow}
          className="btn-quiet text-xs mt-2"
          data-testid="demo-add"
        >
          + Add demographic
        </button>
      </div>
    </section>
  );
}
